import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';

import {Observable} from 'rxjs-compat';
import {RequestCacheService} from '../../shared/services/cache.service';
import {environment} from '../../../environments/environment';

const TTL = environment.cacheDuration;

@Injectable()
export class CachingInterceptor implements HttpInterceptor {

    constructor(private cache: RequestCacheService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const cachedResponse = this.cache.get(`${req.method}_${req.urlWithParams}`);
        return cachedResponse && req.method === 'GET'
            ? Observable.of(cachedResponse)
            : this.sendRequest(req, next);
    }

    sendRequest(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        return next.handle(req).do(event => {
            if (event instanceof HttpResponse) {
                if (req.urlWithParams.match(/https:\/\/api-eu\.preprod\.decathlon\.net\/directory\/v1\/.*/g)) {
                    const res = `${req.method}_${req.urlWithParams}`;
                    this.cache.set(res, event, TTL);
                }
            }
        });
    }
}
